"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipCodeRegex = exports.whiteSpaceRegex = exports.urlForbiddenSymbolRegex = exports.startsWithLetterRegex = exports.simpleEmailRegex = exports.priceRegex = exports.phoneVerificationCodeRegex = exports.passwordRegex = exports.onlyAlphabeticCharactersRegex = exports.nickNameRegex = exports.nameRegex = exports.invalidHttpHeaderCharRegex = exports.dollarsOptionalCentsRegex = void 0;
var onlyAlphabeticCharactersRegex = /^[a-zA-Z]+$/;
exports.onlyAlphabeticCharactersRegex = onlyAlphabeticCharactersRegex;
var nameRegex = /^([a-zA-Z]+((\s-\s)|(-)|(\s))?)+[a-zA-Z]+$/;
exports.nameRegex = nameRegex;
var nickNameRegex = /^[0-9a-zA-Z_]+$/;
exports.nickNameRegex = nickNameRegex;
var startsWithLetterRegex = /^[a-zA-Z]/;
exports.startsWithLetterRegex = startsWithLetterRegex;
var zipCodeRegex = /^[0-9]{5}$/;
// Email with word joiner char has been accidentally submitted before
// https://unicode-explorer.com/c/2060
exports.zipCodeRegex = zipCodeRegex;
var urlForbiddenSymbolRegex = /[/%?&$=+;,:#()\\\u2060]/g;
// From code for Node method http.validateHeaderValue
// https://github.com/nodejs/node/blob/main/lib/_http_common.js#L223
exports.urlForbiddenSymbolRegex = urlForbiddenSymbolRegex;
var invalidHttpHeaderCharRegex = /[^\t\x20-\x7e\x80-\xff]/g;
exports.invalidHttpHeaderCharRegex = invalidHttpHeaderCharRegex;
var passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$/;
exports.passwordRegex = passwordRegex;
var whiteSpaceRegex = /[^\s]/;
exports.whiteSpaceRegex = whiteSpaceRegex;
var priceRegex = /^(\d{1,})*(\.\d{2})?$/;
// No leading zeroes and any values less that 1 dollar
exports.priceRegex = priceRegex;
var dollarsOptionalCentsRegex = /^[1-9][0-9]*\.?(\d{1,2})?$/;
exports.dollarsOptionalCentsRegex = dollarsOptionalCentsRegex;
var phoneVerificationCodeRegex = /\d{6}/;
exports.phoneVerificationCodeRegex = phoneVerificationCodeRegex;
var simpleEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
exports.simpleEmailRegex = simpleEmailRegex;